import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.removeOnCache = () => this.element.remove()
    document.addEventListener("turbo:before-cache", this.removeOnCache)
    this.showToast()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.removeOnCache)
    clearTimeout(this.hideTimeout)
    clearTimeout(this.removeTimeout)
  }

  showToast() {
    this.toastTarget.classList.remove("translate-y-full")
    this.toastTarget.classList.add("translate-y-0")
    this.toastTarget.classList.add("mb-4")

    this.hideTimeout = setTimeout(() => {
      this.hideToast()
    }, 3000)
  }

  hideToast() {
    this.toastTarget.classList.remove("translate-y-0")
    this.toastTarget.classList.add("translate-y-full")
    this.toastTarget.classList.remove("mb-4")
    this.removeTimeout = setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
